import { fm } from 'Components/FormatMessage';
import { Container, Item } from 'Components/Grid';
import HistoryRow from 'Components/HistoryRow';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import { exists } from 'neuro-utils';
import * as React from 'react';
import { formatPartialDate } from 'Utility/date';
import { EN_DASH } from '../../../../../../config/constants';
import { newButton } from '../../../../utils/functions';

import type { IHistoryContext } from 'Containers/FormContextHandler';

const DEFAULT_DOCUMENTS: IDocumentWithTypeV2<'performanceRating'>[] = [];
const PerformanceRatingHistory = ({
  documents = DEFAULT_DOCUMENTS,
  startEdit,
}: IHistoryContext<IDocumentWithTypeV2<'performanceRating'>>): React.JSX.Element => {
  return (
    <HistoryRow
      headerText={fm('diagnosis.sleepApnea.performanceRating.title')}
      rowButton={
        startEdit ? newButton('performanceRating', startEdit({}, 'performanceRating'), 'general.new', 15) : undefined
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <Item xs={12}>
            <Container>
              <Item xs={5}>{fm('general.date')}</Item>
              <Item xs={7}>{fm('diagnosis.sleepApnea.performanceRating.rating')}</Item>
            </Container>
          </Item>
        }
        contentFormat={d => (
          <Item xs={12}>
            <Container>
              <Item xs={5}>{d.date ? formatPartialDate(d.date) : '-'}</Item>
              <Item xs={5} style={{ paddingRight: '1rem' }}>
                {exists(d.rating) ? (
                  <span>
                    {`${d.rating} ${EN_DASH}`} {fm(`diagnosis.sleepApnea.performanceRating.opts.${d.rating}`)}
                  </span>
                ) : (
                  '-'
                )}
              </Item>
              <Item xs={2}>{startEdit ? <HistoryRowControls document={d} startEdit={startEdit} /> : null}</Item>
            </Container>
          </Item>
        )}
        collapse={false}
      />
    </HistoryRow>
  );
};

export default PerformanceRatingHistory;
